import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { api } from "@/lib/api";

export function useAccountApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data) => {
    const token = await getToken();
    return api.request({ method, url: `/account${url}`, data, headers: { Authorization: `Bearer ${token}` } });
  }, [getToken]);
}
